module.exports = __webpack_public_path__ + "ui-static/img/lines-no-items_light.e0506bff.svg";